import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { formatDate } from "../../../core/utils/FormatData";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import {
  exportToCSV,
  exportToExcel,
} from "../../../core/common/GlobalFunctions/exportTableData";
import {
  fetchAllAssetAllocationCountReport,
  fetchAllAssetAllocationCountReportMonthly,
} from "../../../core/data/redux/reports/assestallocatio_report/assetallocation.Action";
import { fetchAllAllocations } from "../../../core/data/redux/asset/assetAllocation/assetAllocationActions";
interface BudgetReportProps {
  showOnlyTable?: boolean;
}

const AssetsAllocationReport: React.FC<BudgetReportProps> = ({ showOnlyTable}) => {
  const { assetAllocations } = useSelector(
    (state: any) => state.asset.assetAllocation
  );
  const [monthlycount, setmonthlycount] = useState<any>(null);
  const [selectedYear, setSelectedYear] = useState("2025");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [tableKey, setTableKey] = useState(0);
  const [countDetails, setcountDetails] = useState<any>(null);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const dispatch = useDispatch<AppDispatch>();

  const data = assetAllocations ? assetAllocations : [];

  function filterAssetAllocations(data: any[]) {
    return data.map((item) => ({
      assetName: item.AssetName || "N/A",
      serialNumber: item.serial_number || "N/A",
      employeeName: item.EmployeeName || "N/A",
      employeeNumber: item.EmployeeNumber || "N/A",
      allocatedAt: item.allocated_at
        ? new Date(item.allocated_at).toLocaleDateString()
        : "N/A",
      expectedReturnDate: item.expected_return_date
        ? new Date(item.expected_return_date).toLocaleDateString()
        : "N/A",
      actualReturnDate: item.actual_return_date
        ? new Date(item.actual_return_date).toLocaleDateString()
        : "N/A",
      allocationStatus: item.allocation_status || "N/A",
      remarks: item.remarks || "-",
    }));
  }

  const data2 = filterAssetAllocations(data);

  const filteredData = useMemo(() => {
     const filters =
      selectedStatus && selectedStatus !== "All"
        ? { allocation_status: selectedStatus }
        : {};
    return filterData(data || [], filters, "CreatedAt", "CreatedAt", selectedSort);
  }, [dispatch, data, assetAllocations, selectedSort, selectedStatus]);

  useEffect(() => {
    dispatch(fetchAllAllocations());
    dispatch(fetchAllAssetAllocationCountReport(selectedYear)).then((res) => {
      setcountDetails(res.payload.data);
    });
  }, []);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, assetAllocations, selectedSort, selectedStatus]);

  const columns = [
    {
      title: "ID",
      dataIndex: "allocation_id",
      render: (text: number, record: any) => (
        <Link to="#">{record.allocation_id}</Link>
      ),
      sorter: (a: any, b: any) => a.allocation_id - b.allocation_id,
    },
    {
      title: "Asset Name",
      dataIndex: "AssetName",
      render: (text: string, record: any) => (
        <h6 className="fw-medium">
          <Link to={all_routes.assetallocationdetails}>{record.AssetName}</Link>
        </h6>
      ),
      sorter: (a: any, b: any) => a.AssetName.length - b.AssetName.length,
    },
    {
      title: "Asset Serial Number",
      dataIndex: "serial_number",
      sorter: (a: any, b: any) =>
        a.serial_number.length - b.serial_number.length,
    },
    {
      title: "Employee Name",
      dataIndex: "EmployeeName",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center ">
          <Link to="#" className="avatar avatar-md">
            <img
              src={record.EmployeePicture}
              alt="img"
              className="img-fluid rounded-circle"
            />
          </Link>
          <div className="ms-2">
            <h6 className="fw-normal">
              <Link to="#">{text}</Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.EmployeeName.length - b.EmployeeName.length,
    },

    {
      title: "Return Date",
      dataIndex: "actual_return_date",
      render: (text: string) => formatDate(text),
      sorter: (a: any, b: any) =>
        a.actual_return_date.length - b.actual_return_date.length,
    },
    {
      title: "EMP ID",
      dataIndex: "EmployeeNumber",
      sorter: (a: any, b: any) =>
        a.EmployeeNumber.length - b.EmployeeNumber.length,
    },
    {
      title: "Status",
      dataIndex: "allocation_status",
      key: "allocation_status",
      render: (status: string) => {
        let style;
        switch (status) {
          case "allocated":
            style = { backgroundColor: "#cce5ff", color: "#004085" };
            break;
          case "returned":
            style = { backgroundColor: "#d4edda", color: "#155724" };
            break;
          case "lost":
            style = { backgroundColor: "#f8d7da", color: "#721c24" };
            break;
          case "damaged":
            style = { backgroundColor: "#fff3cd", color: "#856404" };
            break;
          case "repair":
            style = { backgroundColor: "#e2d6f3", color: "#4b0082" };
            break;
          default:
            style = { backgroundColor: "#e2e3e5", color: "#383d41" };
        }

        return (
          <span
            style={{
              ...style,
              padding: "4px 8px",
              borderRadius: "4px",
              fontWeight: "500",
            }}
          >
            {status}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    if (monthlycount && monthlycount.length > 0) {
      const allocated = new Array(12).fill(0);
      const returned = new Array(12).fill(0);
      const lost = new Array(12).fill(0);
      const damaged = new Array(12).fill(0);
      const repair = new Array(12).fill(0);

      monthlycount.forEach(
        ({
          month,
          allocated: a,
          returned: r,
          lost: l,
          damaged: d,
          repair: rep,
        }: any) => {
          const monthIndex = month - 1;
          allocated[monthIndex] = Number(a);
          returned[monthIndex] = Number(r);
          lost[monthIndex] = Number(l);
          damaged[monthIndex] = Number(d);
          repair[monthIndex] = Number(rep);
        }
      );

      setattendancechart((prev: any) => ({
        ...prev,
        series: [
          { name: "allocated", data: allocated },
          { name: "returned", data: returned },
          { name: "lost", data: lost },
          { name: "damaged", data: damaged },
          { name: "repair", data: repair },
        ],
      }));
    }
  }, [monthlycount]);

  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAllAssetAllocationCountReportMonthly(selectedYear)).then(
        (res) => {
          setmonthlycount(res.payload.data);
        }
      );
    }
  }, [selectedYear]);

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };

  const [attendancechart, setattendancechart] = useState<any>({
    series: [
      { name: "allocated", data: new Array(12).fill(0) },
      { name: "returned", data: new Array(12).fill(0) },
      { name: "lost", data: new Array(12).fill(0) },
      { name: "damaged", data: new Array(12).fill(0) },
      { name: "repair", data: new Array(12).fill(0) },
    ],
    chart: {
      height: 200,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"],
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      labels: {
        offsetX: -15,
      },
    },
    colors: ["#28a745", "#ff69b4", "#007bff", "#ffa500", "#800080", "#dc3545"],
  });


  if (showOnlyTable) {
  return (
   <Table
    key={tableKey}
    dataSource={filteredData}
    columns={columns}
    Selection={true}
    />
  );
}
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Asset Allocation Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Reports</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Asset Allocation Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() =>
                          exportToCSV(data2, "AssetAllocation_Report")
                        }
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() =>
                          exportToExcel(data2, "AssetAllocation_Report")
                        }
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            <div className="col-xl-6 d-flex">
              <div className="row flex-fill">
                {/* Total Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center overflow-hidden mb-2">
                        <div className="attendence-icon">
                          <span>
                            <i className="ti ti-calendar text-primary" />
                          </span>
                        </div>
                        <div className="ms-2 overflow-hidden">
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Total Assets
                          </p>
                          <h4>{countDetails?.[0]?.total}</h4>
                        </div>
                      </div>
                      <div className="attendance-report-bar mb-2">
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Success example"
                          aria-valuenow={countDetails?.[0]?.total}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ height: 5 }}
                        >
                          <div
                            className="progress-bar bg-success"
                            style={{ width: "85%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Total Companies */}
                {/* Total Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center overflow-hidden mb-2">
                        <div className="attendence-icon">
                          <span>
                            <i className="ti ti-calendar text-info" />
                          </span>
                        </div>
                        <div className="ms-2 overflow-hidden">
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Allocated Assets
                          </p>
                          <h4>{countDetails?.[0]?.allocated}</h4>
                        </div>
                      </div>
                      <div className="attendance-report-bar mb-2">
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Success example"
                          aria-valuenow={countDetails?.[0]?.allocated}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ height: 5 }}
                        >
                          <div
                            className="progress-bar bg-success"
                            style={{ width: "85%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Total Companies */}
                {/* Inactive Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center overflow-hidden mb-2">
                        <div className="attendence-icon">
                          <span>
                            <i className="ti ti-calendar text-pink" />
                          </span>
                        </div>
                        <div className="ms-2 overflow-hidden">
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Return Assets
                          </p>
                          <h4>{countDetails?.[0]?.returned}</h4>
                        </div>
                      </div>
                      <div className="attendance-report-bar mb-2">
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Success example"
                          aria-valuenow={countDetails?.[0]?.returned}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ height: 5 }}
                        >
                          <div
                            className="progress-bar bg-success"
                            style={{ width: "85%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Inactive Companies */}
                {/* Company Location */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center overflow-hidden mb-2">
                        <div className="attendence-icon">
                          <span>
                            <i className="ti ti-calendar text-warning" />
                          </span>
                        </div>
                        <div className="ms-2 overflow-hidden">
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Damaged Asset
                          </p>
                          <h4>{countDetails?.[0]?.damaged}</h4>
                        </div>
                      </div>
                      <div className="attendance-report-bar mb-2">
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Success example"
                          aria-valuenow={countDetails?.[0]?.damaged}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ height: 5 }}
                        >
                          <div
                            className="progress-bar bg-success"
                            style={{ width: "85%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Company Location */}
              </div>
            </div>
            <div className="col-xl-6">
              <div className="card">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-line text-danger" />
                      </span>
                      <h5>Asset List</h5>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-2">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2025")}
                          >
                            2025
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2024")}
                          >
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2023")}
                          >
                            2023
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-0 px-2">
                  <ReactApexChart
                    id="payslip-chart"
                    options={attendancechart}
                    series={attendancechart.series}
                    type="line"
                    height={200}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Asset List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                        selectedStatus.slice(1)
                      : "Select Type"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("allocated")}
                        className="dropdown-item rounded-1"
                      >
                        Allocated
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("returned")}
                        className="dropdown-item rounded-1"
                      >
                        Returned
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("lost")}
                        className="dropdown-item rounded-1"
                      >
                        lost
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("damaged")}
                        className="dropdown-item rounded-1"
                      >
                        Damaged
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("repair")}
                        className="dropdown-item rounded-1"
                      >
                       Repair
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default AssetsAllocationReport;
